var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHairB(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 91,
    viewBox: "0 0 128 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0129 51.9909C72.8958 51.5188 107.514 32.757 108.953 2.00711C109.005 0.903747 108.056 -1.44568e-05 106.952 2.29387e-05C19.8004 0.00297347 19.0057 0.385441 19 49.9634C18.9999 51.0679 19.9084 52.0009 21.0129 51.9909Z",
    className: "Hair"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 90.2396V60.1284C0 36.9286 9.96717 15.5632 17.2134 12.1967C49.5 -2.8034 77 -2.80337 111.257 12.6282C120.224 16.6678 128 46.1282 128 60.1284V90.2396C126.847 89.3944 125.503 88.7656 123.948 88.3929C123.983 87.0451 124 85.6827 124 84.3062C124 37.9238 104.169 13 64 13C23.8312 13 4 37.9238 4 84.3062C4 85.6827 4.01747 87.0451 4.05241 88.3929C2.49732 88.7656 1.15329 89.3944 0 90.2396Z",
    className: "Hair"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHairB);
export default __webpack_public_path__ + "static/media/Hair B.ca2693fdba31f270f81a66ef795a6ead.svg";
export { ForwardRef as ReactComponent };